import React, { useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

//import Toast from 'react-bootstrap/Toast';
import Button from "react-bootstrap/Button";
import { auth } from "./component/fbase";
import Container from "react-bootstrap/Container";

import "./Home.css";
//import MenuHeader from './component/MenuHeader';
//import MyNav from './component/MyNav';
//import MyFooter from './component/MyFooter';

const Home = () => {
  // logout event 처리
  const onClick = async (event) => {
    event.preventDefault();
    try {
      // Sign-out successful.
      await auth.signOut();
    } catch (error) {
      console.log(error);
    }
  };
  const user = JSON.parse(sessionStorage.getItem("userInfo"));
  console.log(user);

  return (
    <>
      <div className="header">
        <h1 className="header-title">
          Welcome back, {user.displayName}({user.email})님!
        </h1>
        <p className="header-subtitle"></p>
      </div>
      <main className="content">
        <div className="container-fluid p-0">
          <div className="row mb-2 bm-xl-3"></div>
          <div className="row">
            {/* <div className="col-12 col-sm-6 col-xxl-3 d-flex">교회일정</div>
            <div className="col-12 col-sm-6 col-xxl-3 d-flex">
              오늘의큐티/성경일기
            </div>
            <div className="col-12 col-sm-6 col-xxl-3 d-flex">게시글</div>
            <div className="col-12 col-sm-6 col-xxl-3 d-flex">금주의주보</div> */}
          </div>
        </div>
      </main>

      {/* 
        교회일정, 오늘의 큐티, 오늘의 성경읽기
        게시중 배너, 토스트, 팝업
        주일예배 월 일, 수요예배 월 일
        금주의주보 미등록
        */}
    </>
  );
};

export default Home;
